import { useEffect } from 'react';
import { onMessage } from 'firebase/messaging';
import { useRouter } from 'next/router';
import { createMessagingInstance } from './setup';

/**
 * Designed to be imported dynamically only if the user is signed in.
 *
 * __Do not use directly.__
 */
export default function ForegroundMessagesSetup() {
  const router = useRouter();

  useEffect(() => {
    async function setupForegroundMessageHandler() {
      const messaging = await createMessagingInstance();
      if (!messaging) return;

      onMessage(messaging, (payload) => {
        // Check permissions again in case they have changed
        const permissionGranted = Notification?.permission === 'granted';
        if (!permissionGranted) return;

        // Show the notification
        const notification = new Notification(payload.data.title, {
          body: payload.data.body,
          icon: 'https://www.skyhookadventure.com/images/logo/logo.png',
          data: payload.data,
        });

        // Set the notification click handler to go to the url
        const url = new URL(payload.data.url);
        notification.onclick = () => {
          router.push(url.pathname);
        };
      });
    }

    setupForegroundMessageHandler();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
}
